import { getThemeColor, Styles } from "@mcleod/core";

export const ImageBundleStyles = Styles.make("image-bundle", () => {
    return {
        bundleContainer: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: getThemeColor("defaultBackground"),
            borderRadius: "12px",
            marginBottom: "12px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)"
        },
        bundleHeader: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderBottom: `1px solid ${getThemeColor("subtle.lighter")}`
        },
        bundleTitle: {
            fontWeight: 500,
            fontSize: "16px",
            color: getThemeColor("default")
        },
        bundleCount: {
            fontSize: "14px",
            color: getThemeColor("subtle.dark"),
            marginLeft: "8px"
        },
        thumbnailScroller: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            overflowX: "auto",
            overflowY: "hidden",
            padding: "12px",
            gap: "8px",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none"
        },
        addPageButton: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            borderRadius: "8px",
            border: `2px dashed ${getThemeColor("primary")}`,
            backgroundColor: getThemeColor("primary.lightest"),
            cursor: "pointer"
        },
        addPageIcon: {
            marginBottom: "4px"
        },
        addPageText: {
            fontSize: "12px",
            color: getThemeColor("primary"),
            fontWeight: 500
        }
    };
});


